module.exports = __webpack_public_path__ + "assets/img/相册@3x.69abf635.png";